import { get } from 'lodash';
import { routerReducer } from 'react-router-redux';
import { reducer as toastrReducer } from 'react-redux-toastr';

// Points to shared omega reducers/actions with omegaSharedPaths.js
import { USER_LOGOUT } from 'actions/user';
import app, { defaultAppState } from 'reducers/app';
import errors from 'reducers/errors';
import requests from 'reducers/requests';
import common from 'reducers/common';
import countries from 'reducers/countries';
import ruleTypes from 'reducers/rule-types';
import contacts from 'reducers/contacts';
import media from 'reducers/media';

// RTC reducers
import newTridents from 'reducers/newTridents';
import ucdReducer from 'reducers/ucd';
import debuggingToolsReducer from 'reducers/debugging-tools';

export default function (state = {}, action) {
  if (action.type === USER_LOGOUT) {
    state = {
      app: {
        ...defaultAppState(),
        config: get(state, 'app.config'),
      },
    };
  }

  return {
    ...common(state, action),
    app: app(state.app, action),
    errors: errors(state.errors, action),
    requests: requests(state.requests, action),
    newTridents: newTridents(state.newTridents, action),
    ucd: ucdReducer(state.ucd, action),
    debuggingTools: debuggingToolsReducer(state.debuggingTools, action),
    countries: countries(state.countries, action),
    media: media(state.media, action),
    contacts: contacts(state.contacts, action),
    ruleTypes: ruleTypes(state.ruleTypes, action),
    toastr: toastrReducer(state.toastr, action),

    // @Plop: MODEL_REDUCER
    routing: routerReducer(state.routing, action),
  };
}
